import { screenSmMin } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { List as ListComponent } from "../List";
export var List = styled(ListComponent).withConfig({
  displayName: "List",
  componentId: "vnil8g-0"
})(["flex-wrap:wrap;@media (min-width:", "){align-items:center;display:flex;justify-content:flex-start;}"], screenSmMin);